<template>
  <div class="mySwipe">
    <div class="pre_header" v-if="!defaultShow"></div>
    <van-swipe v-if="defaultShow" @change="onChange" :autoplay="3000">
      <van-swipe-item
        v-for="(e, index) in swipeList"
        :key="index"
        class="swipe-item"
      >
        <img :src="e.bannerPicUrl" :alt="e.bannerName" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
export default {
  name: 'MySwipe',
  data() {
    return {
      swipeList: [],
      current: 1,
      defaultShow: false,
    };
  },
  mounted() {
    this.$api.LoanSupermarket.getBannerInfo()
      .then((res) => {
        if (res.success) {
          this.swipeList = res.data;
          this.defaultShow = true;
        } else {
          this.$toast.fail({
            message: res.returnMessage,
            forbidClick: true,
            duration: 2000,
          });
        }
      })
      .catch(() => {
        this.$toast.fail({
          message: '小望已离开地球，请稍后重试！',
          forbidClick: true,
          duration: 2000,
        });
      });
  },
  methods: {
    onChange(index) {
      this.current = index;
    },
  },
};
</script>
<style scoped>
.mySwipe {
  height: 174px;
}
.pre_header {
  height: 174px;
}
.swipe-item {
  height: 174px;
}
.swipe-item img {
  width: 100%;
  height: 174px;
}
</style>
